import { GET_PAGES } from '../store/constants';
import { getStepPath } from './globalUtils';

export const getHeaderTitle = (path, isHotelOnly: boolean) => {
  const pages = GET_PAGES(isHotelOnly);
  const page = pages.find((item) => item.path === getStepPath(path));

  return page ? page.title : null;
};
